import { render, staticRenderFns } from "./EdimensajeForm.vue?vue&type=template&id=5c303b28"
import script from "./EdimensajeForm.vue?vue&type=script&lang=js"
export * from "./EdimensajeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports